import { HttpService , FallbackProvider } from 'vas-mobile-api';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable()
export class TranslateFallbackProvider implements FallbackProvider {

    constructor(private httpService: HttpService) { }

    loadFallback(): Observable<any> {
        return this.httpService.getLocalResource('./assets/config/default.json');
    }

}
